import React from "react";
import { motion } from "framer-motion";
import {
  SiAngular,
  SiAmazon,
  SiExpress,
  SiMongodb,
  SiMysql,
  SiNodedotjs,
  SiPostgresql,
  SiReact,
  SiRedux,
  SiSocketdotio,
} from "react-icons/si";
import { portfolioData } from "../data/portfolioData";

const iconMap = {
  "Node.js": SiNodedotjs,
  "Express.js": SiExpress,
  MongoDB: SiMongodb,
  MySQL: SiMysql,
  PostgreSQL: SiPostgresql,
  "React.js": SiReact,
  Redux: SiRedux,
  Angular: SiAngular,
  "AWS (S3, EC2)": SiAmazon,
  WebSockets: SiSocketdotio,
};

const Skills = () => {
  const { skills, sections } = portfolioData;

  return (
    <section id="skills" className="py-16 scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-3xl font-bold text-white">{sections.skillsTitle}</h2>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {skills.map((skill, index) => {
            const Icon = iconMap[skill];
            return (
              <motion.article
                key={skill}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.35, delay: index * 0.04 }}
                whileHover={{
                  y: -6,
                  borderColor: "rgba(103, 232, 249, 0.75)",
                  boxShadow: "0 0 22px rgba(34, 211, 238, 0.28)",
                }}
                className="group flex items-center gap-3 rounded-2xl border border-slate-700/60 bg-slate-900/55 px-4 py-4"
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-cyan-300/25 bg-cyan-400/10">
                  {Icon ? (
                    <Icon className="text-lg text-cyan-300 transition group-hover:scale-110" />
                  ) : (
                    <span className="text-xs font-semibold text-cyan-200">SK</span>
                  )}
                </span>
                <span className="text-sm font-medium text-slate-100">{skill}</span>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
